import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Login } from './components/Login';
import { Fields } from './components/Fields';
import { PrivateRoute } from './components/PrivateRoute';
import { PrimeReactProvider } from 'primereact/api';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';

import { ModalNetwork } from './components/ModalNetwork';

function App() {
  const [isNetworkModalOpen, setIsNetworkModalOpen] = useState(!navigator.onLine);

  const isAuthenticated = () => {
    return !!localStorage.getItem('accessToken') && !!localStorage.getItem('refreshToken') && !!localStorage.getItem('email');
  };

  useEffect(() => {
    const handleOnline = () => setIsNetworkModalOpen(false);
    const handleOffline = () => setIsNetworkModalOpen(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      <Router>
        <PrimeReactProvider>
          <ModalNetwork
            isOpen={isNetworkModalOpen}
            message={"No internet connection. Please check your network settings."}
            onClose={() => setIsNetworkModalOpen(false)}
            onConfirm={() => setIsNetworkModalOpen(false)} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/fields" element={<PrivateRoute element={Fields} />} />
            { /*<Route path="/notifications" element={<PrivateRoute element={Notifications} />} /> */}
            <Route path="*" element={isAuthenticated() ? <Navigate to="/fields" replace /> : <Navigate to="/login" replace />} />
          </Routes>
        </PrimeReactProvider>
      </Router>
    </>
  );
}

export default App;
